import { loadRecipeForPlay,loadRecipeForSearch } from './actions/recipe';
import {showQuiz} from './actions/question';
import {requestScore} from './actions/score';
import {loadUser} from './actions/user';
import { ROUTES } from './constants'; 
export default {
	[ROUTES.LANDING_PAGE] : {
		path : '/'
	},
	[ROUTES.HOME_PAGE] : {
		path : '/home/',
	},
	[ROUTES.SEARCH_QUIZ_SELECTED] : {
		path : '/search-quiz/'
	},
	[ROUTES.SEARCH_QUIZ_QUERIED] : {
		path : '/search-quiz/:key'
	},
	[ROUTES.CREATE_QUIZ_SELECTED]:'/create-quiz/',
	[ROUTES.SHOW_RECIPE]:{
		path:'/create-quiz/:recipeId',
	},
	[ROUTES.REQUEST_QUIZ_EDITOR]:{
		path:'/create-quiz/:recipeId/:quizId',
		thunk:showQuiz
	},
	[ROUTES.REQUEST_PLAY_QUIZ]:{
		path:'/play-quiz/:userId/:recipeId',
		thunk:loadRecipeForPlay
	},
	[ROUTES.PROFILE]:{
		path:'/profile',
	},
	[ROUTES.RECIPE_DETAIL]:{
		path:'/recipe-detail/:recipeId',
		thunk:(dispatch, getState)=>{
			loadRecipeForSearch(dispatch,getState);
			requestScore(dispatch,getState);
		}
	},
	[ROUTES.USER]:{
		path:'/users/:userId',
		thunk:loadUser
	},
	[ROUTES.TERMS_PAGE]:{
		path:'/terms',
	},
	[ROUTES.PRIVACY_POLICY_PAGE]:{
		path:'/privacy-policy'
	}
};